<block-ui>

  <div class="login-page" *ngIf="isLogin">
      <div class="form">
          <form (ngSubmit)="onSubmit()" [formGroup]="userForm">

              <div class="no-border no-padding padding-top">
                  <img src="./assets/img/A-64.png" class="d-inline-block align-top" alt="" style="margin-left: auto !important; margin-right: auto !important; display: block !important; height: 30px !important;">
              </div>
              <h3>Iniciar sesión</h3>
              <div class="form-group padding-top">
                  <input type="text" formControlName="email" class="form-control no-margin" placeholder="Usuario" [ngClass]="{ 'is-invalid': fUser.email.errors && fUser.email.touched }" />
                  <div *ngIf="fUser.email.errors" class="invalid-feedback">
                      <div *ngIf="fUser.email.errors.required">El usuario es requerido</div>
                  </div>

              </div>

              <div class="form-group">
                  <input type="password" formControlName="password" class="form-control no-margin" placeholder="Contraseña" [ngClass]="{ 'is-invalid': fUser.password.errors && fUser.password.touched }" />
                  <div *ngIf="fUser.password.errors" class="invalid-feedback">
                      <div *ngIf="fUser.password.errors.required">La contraseña es requerida</div>
                  </div>
              </div>

              <div class="form-group">
                  <button type="submit" [disabled]="userForm.invalid" class="btn btn-primary">Login</button>
                  <!-- <p class="message">Bienvenido, desea crear una cuenta? <a (click)="clickEvent(false, false)">Sign Up</a></p> -->
                  <p class="message">Bienvenido, olvidó su contraseña? <a (click)="clickEvent(false, true)">Recuperar Contraseña</a></p>
              </div>

          </form>

      </div>
  </div>
  <div class="login-page" *ngIf="forgotPwsd">
        <div class="form">
            <form (ngSubmit)="onSubmit()" [formGroup]="userForm">
  
                <div class="no-border no-padding padding-top">
                    <img src="./assets/img/A-64.png" class="d-inline-block align-top" alt="" style="margin-left: auto !important; margin-right: auto !important; display: block !important; height: 30px !important;">
                </div>
  
                <div class="form-group padding-top">
                    <input class="form-control no-margin" type="text" formControlName="email" placeholder="Email" [ngClass]="{ 'is-invalid': fUser.email.errors && fUser.email.touched }">
                    <div *ngIf="fUser.email.errors" class="invalid-feedback">
                        <div *ngIf="fUser.email.errors.required">El usuario es requerido</div>
                    </div>
                </div>
  
                <div class="form-group">
                    <button [disabled]="loading" class="btn btn-primary">Enviar Correo</button>
                    <img *ngIf="loading" class="pl-3" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                    />
                    <p class="message">Bienvenido, usted puede iniciar sesión? <a (click)="clickEvent(true, false)">Iniciar Sesión</a></p>
                </div>
              </form>
        </div>
    </div>
  <!-- <div class="login-page" *ngIf="!isLogin && !forgotPwsd">
      <div class="form">
          <form novalidate (ngSubmit)="onSubmit()" [formGroup]="userForm">
              <h3><img src="favicon.ico"> Facturación Electrónica</h3>
              <div class="form-group">
                  <input class="form-control no-margin" type="text" formControlName="fullName" placeholder="Nombre Completo" [ngClass]="{ 'is-invalid': fUser.fullName.errors && fUser.fullName.touched }">
                  <div *ngIf="fUser.fullName.errors" class="invalid-feedback">
                      <div *ngIf="fUser.fullName.errors.required">El nombre es requerido</div>
                  </div>
              </div>

              <div class="form-group">
                  <input class="form-control no-margin" type="text" formControlName="email" placeholder="Usuario" [ngClass]="{ 'is-invalid': fUser.email.errors && fUser.email.touched }">
                  <div *ngIf="fUser.email.errors" class="invalid-feedback">
                      <div *ngIf="fUser.email.errors.required">El usuario es requerido</div>
                  </div>
              </div>

              <div class="form-group">
                  <input class="form-control no-margin" type="text" formControlName="identification" placeholder="Cédula" [ngClass]="{ 'is-invalid': fUser.identification.errors && fUser.identification.touched }">
                  <div *ngIf="fUser.identification.errors" class="invalid-feedback">
                      <div *ngIf="fUser.identification.errors.required">La cédula es requerida</div>
                  </div>
              </div>

              <div class="form-group">
                  <input class="form-control no-margin" type="password" formControlName="password" id="password" placeholder="Contraseña" [ngClass]="{ 'is-invalid': fUser.password.errors && fUser.password.touched }">
                  <div *ngIf="fUser.password.errors" class="invalid-feedback">
                      <div *ngIf="fUser.password.errors.required">La contraseña es requerida</div>
                  </div>
              </div>

              <div class="form-group">
                  <input class="form-control no-margin" type="password" formControlName="confirmPassword" id="confirmPassword" placeholder="Confirme la Contraseña" [ngClass]="{ 'is-invalid': fUser.confirmPassword.errors && fUser.confirmPassword.touched }">
                  <div *ngIf="fUser.confirmPassword.errors" class="invalid-feedback">
                      <div *ngIf="fUser.confirmPassword.errors.required">La confirmacion de la contraseña es requerida</div>
                  </div>
              </div>

              <div class="form-group">
                  <button type="submit" class="btn btn-primary" [disabled]="userForm.invalid">Sign Up</button>
              </div>

              <p class="message">Bienvenido, usted puede iniciar sesión? <a (click)="clickEvent(true, false)">Login</a></p>
              <p class="message">Bienvenido, olvidó su contraseña? <a (click)="clickEvent(false, true)">Recovery password</a></p>
          </form>

      </div>
  </div>

  
   -->

</block-ui>